export const assetCategoriesDetails = [
    {  
		checkbox: true,
		name: "Headsets",
		status:"Active",
        key:1
	},
	{   
		checkbox: true,
		name: "Keyboards",
		status:"Active",
        key:2
	},
	{
		checkbox: true,
		name: "Laptops",
		status:"Active",
        key:3
	},
	{
		checkbox: true,
		name: "Mobile Phones",
		status:"Active",
        key:4
	},
	{
		checkbox: true,
		name: "Mouse",
		status:"Active",
        key:5
	},
	{
		checkbox: true,
		name: "Office Furnitures",
		status:"Active",
        key:6
	},
	{
		checkbox: true,
		name: "Printers",
		status:"Active",
        key:7
	},
	{
		checkbox: true,
		name: "Projectors",
		status:"Active",
        key:8
	},
	{
		checkbox: true,
		name: "Scanners",
		status:"Active",
        key:9
	},
	{
		checkbox: true,
		name: "Tablets",
		status:"Active",
        key:10
	}
];
